import { Box, Grid2 } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomTypography from '@ui-components/Typography/CustomTypography';

// Icon
import ArrowUp from '@assets/images/arrows-up.svg';
import CheckIcon from '@assets/images/check.svg';
import { useFontSize } from '@qler-view/shared_lib/src/shared/lib/providers/FontSizeContext';

import CurrentDate from '../components/Date';
import CurrentTime from '../components/Time';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import CustomListItemIcon from '@ui-components/List/CustomListItemIcon';
import CustomMenu from '@ui-components/Menu/CustomMenu';
import CustomMenuItem from '@ui-components/Menu/CustomMenuItem';
import CustomMenuList from '@ui-components/Menu/CustomMenuList';
import PageTitle from './Pagetitle';

const Appbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { fontSize, setFontSize } = useFontSize();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    return () => {
      document.documentElement.style.zoom = '1';
    };
  }, []);

  return (
    <Box className="pb-24">
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 7, xl: 7 }}>
          <CustomTypography
            id="page-title"
            variant="h4"
            className="text-left pt-16"
          >
            <PageTitle />
          </CustomTypography>
        </Grid2>
        <Grid2
          className="justify-end"
          size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }}
        >
          <Box className="flex float-right">
            <Box
              className="box-border courser-pointer flex mr-16"
              onClick={handleMenuOpen}
            >
              <CustomTypography
                className="pr-6"
                id="date-time"
                color="textDisabled"
                variant="body2"
              >
                {fontSize.charAt(0).toUpperCase() + fontSize.slice(1)}
              </CustomTypography>
              <ArrowUp />
            </Box>
            <Box className="box-border bb-width flex">
              <Box className="pr-8">
                <CustomTypography
                  id="date-time"
                  color="textPrimary"
                  variant="body2"
                >
                  <CurrentDate />
                </CustomTypography>
              </Box>
              <Box>
                <CustomTypography
                  id="date-time"
                  color="textPrimary"
                  variant="body2"
                >
                  <CurrentTime />
                </CustomTypography>
              </Box>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      <Box>
        <CustomMenu
          id="accessibility-menu"
          anchorEl={anchorEl ?? document.body}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <CustomMenuList>
            <CustomMenuItem
              onClick={() => {
                setFontSize('small');
                handleMenuClose();
              }}
            >
              <CustomTypography id="small-font" variant="h6" className="pr-24">
                Small
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'small' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
            <CustomDivider />
            <CustomMenuItem
              onClick={() => {
                setFontSize('medium');
                handleMenuClose();
              }}
            >
              <CustomTypography id="medium-font" variant="h5" className="pr-24">
                Medium
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'medium' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
            <CustomDivider />
            <CustomMenuItem
              onClick={() => {
                setFontSize('large');
                handleMenuClose();
              }}
            >
              <CustomTypography id="large-font" variant="h4" className="pr-24">
                Large
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'large' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
          </CustomMenuList>
        </CustomMenu>
      </Box>
    </Box>
  );
};
export default Appbar;
